import { createRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { Center, Spinner } from '@chakra-ui/react'
import { authenticatedRoute } from '../_authenticated'
import { parseIssueId } from '@/lib/digest/issueId'

const Dashboard = lazy(() => import('@/pages/dashboard').then(m => ({ default: m.Dashboard })))
const DigestArchiveScreen = lazy(() => import('@/pages/dashboard/DigestArchiveScreen'))
const PastIssueScreen = lazy(() => import('@/pages/dashboard/PastIssueScreen'))

function RouteFallback() {
  return <Center h="100vh"><Spinner size="lg" color="purple.500" /></Center>
}

function DashboardWrapper() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Dashboard />
    </Suspense>
  )
}

function DigestArchiveWrapper() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <DigestArchiveScreen />
    </Suspense>
  )
}

function PastIssueWrapper() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <PastIssueScreen />
    </Suspense>
  )
}

export const dashboardRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/dashboard',
  component: DashboardWrapper,
})

// D51f Phase 4. `Dashboard` renders no `<Outlet/>`, so these are SIBLINGS of
// `dashboardRoute` under the authenticated layout (which supplies the auth
// redirect and the tab chrome), not nested children of it.
export const digestArchiveRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/dashboard/issues',
  component: DigestArchiveWrapper,
})

export const pastIssueRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/dashboard/issues/$id',
  // A positive integer, or `null` — `PastIssueScreen` renders its calm
  // not-found state for `null` (a throw here would reach the generic error
  // boundary instead). See `parseIssueId` for what counts.
  params: {
    parse: ({ id }) => ({ id: parseIssueId(id) }),
    stringify: ({ id }) => ({ id: id === null ? '' : String(id) }),
  },
  component: PastIssueWrapper,
})
